export default "__VITE_ASSET__By7S23y7__"